import { OrganizationUsers } from "@/pages/organisaties/medewerkers/OrganizationUsers"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/organisatie-profiel/medewerkers/")({
  component: RouteComponent,
  beforeLoad: () => {
    return checkOrganizationPermissions("read", "contactStudentConnection")
  },
})

function RouteComponent() {
  return <OrganizationUsers />
}
